import { CProgress, CProgressBar, CButton } from '@coreui/bootstrap-react/src/index';
import * as React from 'react';
export default {
  CProgress,
  CProgressBar,
  CButton,
  React
};